exports.components = {
  "component---src-components-index-js": () => import("./../../../src/components/index.js" /* webpackChunkName: "component---src-components-index-js" */),
  "component---src-pages-checkout-js": () => import("./../../../src/pages/checkout.js" /* webpackChunkName: "component---src-pages-checkout-js" */),
  "component---src-pages-preview-js": () => import("./../../../src/pages/preview.js" /* webpackChunkName: "component---src-pages-preview-js" */)
}

